import { render, staticRenderFns } from "./accountingAccount.vue?vue&type=template&id=0ff20a99&scoped=true"
import script from "./accountingAccount.vue?vue&type=script&lang=js"
export * from "./accountingAccount.vue?vue&type=script&lang=js"
import style0 from "./accountingAccount.vue?vue&type=style&index=0&id=0ff20a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff20a99",
  null
  
)

export default component.exports